import {MapEvent} from '../events';
import {MapProps} from './props';
import {AreaConstants, DetailStoreState, utils} from '@mc/redux';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';

/**
 * Mapuje stav do properties.
 *
 * @param state - Stav store.
 * @param ownProps - Vlastní properties.
 * @returns Properies.
 * @ignore
 */
function mapStateToProps<Event extends MapEvent>(state: any, ownProps: MapProps<Event>) {
    return {
        authInfo: utils.storeFromArea(state, AreaConstants.AUTH_INFO_AREA, false) as DetailStoreState,
    };
}

/**
 * Mapuje dispatch do properties.
 *
 * @param dispatch - Dispatch funkce
 * @param ownProps - Vlastní properties.
 * @returns Properties.
 * @ignore
 */
function mapDispatchToProps<Event extends MapEvent>(dispatch: Dispatch, ownProps: MapProps<Event>) {
    return {
        dispatch,
    };
}

/**
 * Napojí komponentu mapy do store bez konfigurace mapy.
 *
 * @param component - Komponenta pro napojení.
 * @returns Napojená komponenta.
 * @ignore
 */
export default function connectBase<CustomProps, Event extends MapEvent>(component) {
    return connect<
        ReturnType<typeof mapStateToProps>,
        ReturnType<typeof mapDispatchToProps>,
        CustomProps & MapProps<Event>
    >(
        mapStateToProps,
        mapDispatchToProps,
    )(component);
}
